import React, { Fragment } from 'react';
import { CFormCheck, CFormFeedback, CFormInput, CFormLabel, CFormTextarea } from '@coreui/react-pro';
import PropTypes from 'prop-types';

const SimpleOtherOptionRadiosGroup = ({
     name,
     label,
     radios,
     isRequired,
     value,
     otherOption,
     otherAnswer,
     hasOtherAnswer,
     error,
     setFieldValue,
     onChangeOtherOption,
     onChangeOtherAnswer,
     disabled,
     className,
     classRadioGroup,
     rows,
}) => {
     const otherOptionInput = radios.find((rad) => rad.otherOption);
     return (
          <div className={` form-group ${className ? className : ''}`}>
               {label && (
                    <CFormLabel className="question-title">
                         {label}
                         {isRequired && <span className="text-danger">*</span>}
                    </CFormLabel>
               )}

               <div className={`radios-group-wrapper ${classRadioGroup}`}>
                    {radios?.map?.((radio, index) => {
                         const isOtherOption = radio.otherOption && radio.value === value;

                         return (
                              <Fragment key={index}>
                                   {isOtherOption ? (
                                        <>
                                             <div className="form-check">
                                                  <CFormCheck
                                                       key={name + index}
                                                       id={name + index}
                                                       name={name}
                                                       type="radio"
                                                       className="me-2"
                                                       invalid={isRequired && !!error}
                                                       checked={radio.value === value}
                                                       disabled={disabled}
                                                       onChange={() => setFieldValue(name, radio.value)}
                                                  />
                                                  {/* text Other */}
                                                  <label className="form-check-label">{radio.label}</label>
                                             </div>
                                        </>
                                   ) : (
                                        <CFormCheck
                                             key={index}
                                             type="radio"
                                             name={name}
                                             id={name + index}
                                             label={radio.label}
                                             invalid={isRequired && !!error}
                                             checked={radio.value === value}
                                             onChange={() => setFieldValue(name, radio.value)}
                                             disabled={disabled}
                                        />
                                   )}
                              </Fragment>
                         );
                    })}
                    {otherOptionInput && otherOptionInput.value === value && (
                         <div className="other-option">
                              <CFormTextarea
                                   className="input-custom"
                                   id={name}
                                   name={name}
                                   invalid={isRequired && !!error}
                                   value={typeof otherOption !== 'undefined' ? otherOption : ''}
                                   onChange={onChangeOtherOption}
                                   disabled={disabled}
                                   rows={rows || 2}
                                   placeholder={otherOptionInput.otherPlaceholder ? otherOptionInput.otherPlaceholder : 'If no, please explain.'}
                              />
                         </div>
                    )}
               </div>
               {hasOtherAnswer && (
                    <CFormInput
                         id={name}
                         name={name}
                         type="text"
                         value={typeof otherAnswer !== 'undefined' ? otherAnswer : ''}
                         invalid={isRequired && !!error}
                         onChange={onChangeOtherAnswer}
                         disabled={disabled}
                         autoComplete="off"
                         placeholder="If no, please explain."
                         className="mt-2 input-custom"
                    />
               )}

               {isRequired && <CFormFeedback invalid>{error}</CFormFeedback>}
          </div>
     );
};

SimpleOtherOptionRadiosGroup.propTypes = {
     name: PropTypes.string,
     label: PropTypes.string,
     radios: PropTypes.array,
     isRequired: PropTypes.bool,
     isOtherOption: PropTypes.bool,
     value: PropTypes.any,
     error: PropTypes.string,
     setFieldValue: PropTypes.func,
     onChangeTextOption: PropTypes.func,
     disabled: PropTypes.bool,
     className: PropTypes.string,
     classRadioGroup: PropTypes.string,
};

SimpleOtherOptionRadiosGroup.defaultProps = {
     value: '',
     classRadioGroup: 'd-flex align-items-center',
};

export default SimpleOtherOptionRadiosGroup;
